import React, { Component } from 'react'
import { getAttribute } from '../utils/models'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

export default (WrappedComponent) => {

  return class extends Component {

    render() {
      const attribute = getAttribute(this.props.model, this.props.attribute)
      let required = attribute && attribute.required ? true : false

      if (this.props.hasOwnProperty('required')) {
        required = this.props.required
      }

      let fieldSettings = {
        rules: [{
          required,
          message: (
            <span>
              El campo <FormattedMessage id={`Attribute.${this.props.model}.${this.props.attribute}`} /> es obligatorio
            </span>
          )
        }]
      }

      if (this.props.hasOwnProperty('validator')) {
        _.first(fieldSettings.rules).validator = this.props.validator
      }

      if (this.props.value) {
        fieldSettings.initialValue = this.props.value
      }

      return <WrappedComponent fieldSettings={fieldSettings} {...this.props} />
    }

  }

}



// WEBPACK FOOTER //
// ./src/hocs/withFieldSettings.js